import { trigger, transition, style, animate } from '@angular/animations';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { Subscription } from 'rxjs';
import { SafeAreaService } from '../../@services/webview/safe-area.service';

@Component({
    selector: 'vw-toast-popup',
    templateUrl: './toast-popup.component.html',
    styleUrl: './toast-popup.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToastPopupComponent implements OnInit, OnChanges, OnDestroy {

  constructor(private renderer: Renderer2) { }

  private readonly safeAreaService = inject(SafeAreaService);
  private safeAreaSubscription?: Subscription;

  /** Encoche haute remontée par le wrapper natif, en pixels. */
  private safeAreaTop = 0;

  /** Controls the visibility of the bottom sheet */
  @Input() isOpen = false;

  /** Padding top of the bottom sheet */
  @Input() paddingTop = '80px';

  /** Width of the bottom sheet */
  @Input() width = '100%';

  /** Border radius of the bottom sheet */
  @Input() borderRadius = '0';

  /** Custom Tailwind CSS classes */
  @Input() customClass = '';

  @Input() toastCustomClass = '';

  @Output() close = new EventEmitter<void>();

  ngOnInit() {
    this.safeAreaSubscription = this.safeAreaService.safeAreaData$.subscribe(
      (data) => (this.safeAreaTop = data?.top ?? 0),
    );
  }

  /**
   * Retrait haut réellement appliqué.
   *
   * `paddingTop` seul est une valeur FIXE choisie par l'appelant : sur un
   * téléphone à encoche haute, la feuille passait sous l'heure et la batterie.
   * On garde la valeur demandée, mais jamais moins que l'encoche réelle
   * remontée par le wrapper natif — plus une marge pour que la croix de
   * fermeture ne colle pas au bord.
   *
   * `env(safe-area-inset-top)` ne suffirait pas : `viewport-fit=cover` n'est
   * pas activé sur ce projet, la variable vaut donc zéro partout.
   */
  get effectivePaddingTop(): string {
    const floor = this.safeAreaTop > 0 ? `${this.safeAreaTop + 12}px` : '0px';
    return `max(${this.paddingTop}, ${floor})`;
  }

  ngOnChanges() {
    if (this.isOpen) {
      this.renderer.addClass(document.body, 'bottom-sheet-open');
    } else {
      this.renderer.removeClass(document.body, 'bottom-sheet-open');
    }
  }

  ngOnDestroy() {
    this.safeAreaSubscription?.unsubscribe();
    // Remove the class if the component is destroyed to avoid leaving it applied
    this.renderer.removeClass(document.body, 'bottom-sheet-open');
  }
}
